import {
  TradevestCatalogInstrumentsResponse,
  TradevestDocLang,
  TradevestPriceHistoryResponse,
  TradevestPriceRange,
} from '@mygate/common';
import { api } from './api';

export interface CatalogInstrumentsParams {
  assetType?: string;
  tradingStatus?: string;
  exchangeCode?: string;
  isin?: string;
  /** Upstream's spelling. Was `savingsPlan`, which Tradevest silently ignored (MYG-548). */
  savingsPlansEligible?: boolean;
  search?: string;
  limit?: number;
  cursor?: string;
}

/**
 * Read-only access to the live Tradevest traditional-asset catalog (MYG-397) — staff overview of the
 * third-party instrument universe, separate from the curated internal AssetModel catalog.
 */
class TradevestCatalogService {
  async listInstruments(params: CatalogInstrumentsParams = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        qs.append(key, String(value));
      }
    });
    const queryString = qs.toString();
    return api.get<TradevestCatalogInstrumentsResponse>(
      `/api/staff/tradevest/catalog/instruments${queryString ? `?${queryString}` : ''}`,
    );
  }

  async getHistory(isin: string, range: TradevestPriceRange) {
    return api.get<TradevestPriceHistoryResponse>(
      `/api/staff/tradevest/catalog/instruments/${encodeURIComponent(isin)}/history?range=${range}`,
    );
  }

  async downloadKid(isin: string, language: TradevestDocLang = 'de') {
    return api.fetchBlob(
      `/api/staff/tradevest/catalog/instruments/${encodeURIComponent(isin)}/kid?language=${language}`,
    );
  }
}

export const tradevestCatalogService = new TradevestCatalogService();
